'use client';

import {
  SiteHeader as ChromeSiteHeader,
  type HeaderNavItem,
} from '@/components/chrome/site-header';
import { SearchButton } from '@/components/search';
import { ThemeAwareLogo } from '@/components/common';
import { NAVIGATION, BLOG_NAV, WORK_NAV } from '@/lib/navigation';
import { trackThemeToggle } from '@/lib/analytics';

/**
 * Site Header — thin wrapper around the registry-installed chrome header.
 *
 * Site config (nav items, dropdown shapes, logo, search, analytics) lives
 * here; all rendering/behavior lives in @/components/chrome/site-header.
 */
const HEADER_LINKS: HeaderNavItem[] = NAVIGATION.header.map((item) => {
  if (item.label === 'Blog') {
    return {
      ...item,
      dropdown: {
        ariaLabel: 'Blog menu',
        activePrefix: '/blog',
        items: BLOG_NAV,
        dividerAfterIndex: 1,
      },
    };
  }
  if (item.label === 'Work') {
    return {
      ...item,
      dropdown: {
        ariaLabel: 'Our Work menu',
        activePrefix: '/work',
        items: WORK_NAV,
        dividerAfterIndex: WORK_NAV.length - 4,
      },
    };
  }
  return item;
});

export function SiteHeader() {
  return (
    <ChromeSiteHeader
      logo={
        <ThemeAwareLogo
          width={28}
          height={28}
          className="w-[clamp(1.75rem,2vw+1rem,1.75rem)] h-[clamp(1.75rem,2vw+1rem,1.75rem)] rounded-full"
        />
      }
      logoAriaLabel="DCYFR Labs Home"
      links={HEADER_LINKS}
      actions={<SearchButton variant="default" />}
      mobileNavSections={NAVIGATION.mobile}
      onThemeChange={trackThemeToggle}
    />
  );
}
